export default {"src":"/_next/static/media/GS-Icon-Video.13445928.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};